import React from 'react';
import CloseV2Svg from '@atlas-design-system/core/dist/svg/close-v2.svg';

import IconBase from './IconBase';

const CloseV2Icon = React.forwardRef((props, ref) => (
  <IconBase {...props} ref={ref} Icon={CloseV2Svg} />
));

CloseV2Icon.displayName = 'CloseV2Icon';

export default CloseV2Icon;
